import { FC } from 'react';

import { IconProps } from '../types';

const FirmingIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M29.2372 10.0473C26.5651 10.7853 25.9667 11.3837 25.2287 14.0558C24.4907 11.3837 23.8922 10.7853 21.2202 10.0473C23.8922 9.30928 24.4907 8.71085 25.2287 6.03882C25.9667 8.71085 26.5651 9.30928 29.2372 10.0473Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.4098 31.1964C27.0696 31.8424 26.5456 32.3665 25.8995 34.7067C25.2534 32.3665 24.7294 31.8424 22.3892 31.1964C24.7294 30.5503 25.2534 30.0263 25.8995 27.686C26.5456 30.0263 27.0696 30.5503 29.4098 31.1964Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.0781 20.2534C33.1528 21.0616 32.4975 21.716 31.6902 24.6413C30.8828 21.716 30.2275 21.0616 27.3022 20.2534C30.2275 19.446 30.8828 18.7908 31.6902 15.8655C32.4975 18.7908 33.1528 19.446 36.0781 20.2534Z"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4424 15.0212C11.4278 15.9389 12.8687 16.341 14.1859 16.066"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.186 5.28003C17.1673 7.09872 17.5141 9.17232 17.4782 11.2392C17.4623 12.1419 17.347 13.0546 17.5241 13.9397C17.642 14.5273 17.8869 15.0839 18.1886 15.6021C18.6566 16.4061 19.2659 17.1283 19.9797 17.725C20.1853 17.8972 20.4051 18.0652 20.5347 18.2992C20.8631 18.8935 20.4494 19.6783 19.8477 19.9917C19.245 20.3051 18.5296 20.2775 17.8518 20.2424"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.8252 28.6523C7.12357 29.7697 8.30706 30.2528 9.42953 30.5328C11.5274 31.0552 13.6854 31.4422 15.8426 31.3001C16.8263 31.2357 17.9922 30.9014 18.258 29.9519C18.4895 29.1228 18.4419 28.2962 18.3784 27.4379C18.8205 27.259 19.1749 26.6238 19.2225 26.1499"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1158 20.219C19.1166 20.5575 19.0999 20.8199 19.1124 21.1409C19.1166 21.2445 19.1208 21.3498 19.1492 21.4501C19.2503 21.8037 19.6273 22.016 19.7551 22.3603C19.893 22.7314 19.7042 23.1434 19.4676 23.4602C19.2002 23.8188 18.8642 24.1263 18.4831 24.3612C18.3635 24.4356 18.239 24.5024 18.1095 24.5576C17.8395 24.6738 17.5503 24.7406 17.2578 24.7716C17.053 24.7933 16.8466 24.7983 16.6401 24.7858"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1855 16.0651C14.4898 15.725 14.4864 14.9719 14.4304 14.6108"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3354 12.2707C11.6435 11.3923 13.4371 11.2694 15.0159 11.6856"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.8999 10.5154C5.8005 11.0729 7.91757 10.5597 9.63345 9.571C11.3502 8.58309 12.8329 6.98171 13.8459 5.28003"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FirmingIcon;
